import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface TenantMemberDepositState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: TenantMemberDepositState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const tenantMemberDepositSelects = {
  loading: (state: RootState) => state.tenantMemberDeposit.loading,
  dateRange: (state: RootState) => state.tenantMemberDeposit.dateRange,
  queryParams: (state: RootState) => state.tenantMemberDeposit.queryParams,
  transfers: (state: RootState) => state.tenantMemberDeposit.transfers,
};

export const tenantMemberDepositThunks = {
  list: createAsyncThunk(
    "tenantMemberDeposit/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.MemberDeposit,
      }).run();

      return res.data.msg;
    }
  ),
};

export const tenantMemberDepositSlice = createSlice({
  name: "tenantMemberDeposit",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantMemberDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tenantMemberDepositThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(tenantMemberDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const tenantMemberDepositActions = tenantMemberDepositSlice.actions;
